<style lang="scss" scoped>
.flex-container {
    display: flex;

    .input-item {
        width: 40%;
    }
    .tip-item {
        width: 40%;
        margin-left: 60px;

        .tip-p {
            color: #ed4014;
            p {
                line-height: 23px;
            }
        }
    }
}
</style>
<template>
    <div style="position: relative">
        <compWrapper
            :title="$t('erp.rules.rulenews', { defaultValue: '规则信息' })"
            theme="primary"
        >
            <compFormQuery
                v-if="queryType == 'query'"
                class="margin-top-15 margin-right-15"
                :formdata="getBase"
                :value="baseInfo"
                :labelWidth="120"
            ></compFormQuery>
            <compFormEdit
                v-else
                class="margin-top-15 margin-right-15"
                ref="editform"
                :formdata="getBase"
                v-model="baseInfo"
                :labelWidth="120"
            ></compFormEdit>
            <template v-if="queryType !== 'query'" slot="footer">
                <Button class="margin-right-20" type="info" @click="submit">{{
                    $t("global.common.save", { defaultValue: "保存" })
                }}</Button>
                <Button class="margin-right-20" @click="cancel">{{
                    $t("global.common.operation_cancel", {
                        defaultValue: "取消",
                    })
                }}</Button>
            </template>
        </compWrapper>
        <compWrapper
            :title="$t('erp.rules.rulechose', { defaultValue: '规则筛选条件' })"
            theme="primary"
        >
            <Form
                v-if="queryType == 'query'"
                :model="formData"
                :labelWidth="150"
                style="padding: 15px 0"
            >
                <FormItem
                    :label="
                        $t('erp.b2c.channel_account', {
                            defaultValue: '渠道账号',
                        })
                    "
                >
                    <div class="font-weight">
                        <div v-if="formData.accountType === 'all'">
                            {{ $t("bi.work.task_all", { defaultValue: "全部" })
                            }}{{
                                $t("global.common.channel", {
                                    defaultValue: "渠道",
                                })
                            }}
                        </div>
                        <div v-else>
                            <p v-for="item in targetAccountList" :key="item">
                                {{ item }}
                            </p>
                        </div>
                    </div>
                </FormItem>
                <FormItem
                    :label="
                        $t('global.common.project', { defaultValue: '项目' })
                    "
                >
                    <div class="font-weight">
                        <div v-if="formData.productType === 'all'">
                            {{ $t("bi.work.task_all", { defaultValue: "全部" })
                            }}{{
                                $t("global.common.project", {
                                    defaultValue: "项目",
                                })
                            }}
                        </div>
                        <div v-else>
                            <p v-for="item in targetProductList" :key="item">
                                {{ item }}
                            </p>
                        </div>
                    </div>
                </FormItem>
                <FormItem label="地址">
                    <div class="font-weight">
                        <div v-if="formData.addressType == 'all'">
                            全部地址
                        </div>
                        <div v-else>
                            <p>住宅地址</p>
                        </div>
                    </div>
                </FormItem>
                <FormItem
                    :label="
                        $t('erp.rules.postlength', { defaultValue: '邮编范围' })
                    "
                >
                    <div class="font-weight">
                        <div v-if="!dataList.postcodeList.length">--</div>
                        <div v-else>
                            <p
                                v-for="item in dataList.postcodeList"
                                :key="item.key"
                            >
                                {{ item }}
                            </p>
                        </div>
                    </div>
                </FormItem>
                <FormItem label="ERPSKU">
                    <div class="font-weight">
                        <div v-if="!dataList.skuList.length">--</div>
                        <div v-else>
                            <p v-for="item in dataList.skuList" :key="item.key">
                                {{ item }}
                            </p>
                        </div>
                    </div>
                </FormItem>
                <FormItem label="动态条件">
                    <div class="font-weight">
                        <div v-if="!dataList.erpskuSizeFormulaList.length">
                            --
                        </div>
                        <div v-else>
                            <p
                                v-for="item in dataList.erpskuSizeFormulaList"
                                :key="item.key"
                            >
                                {{ item }}
                            </p>
                        </div>
                    </div>
                </FormItem>
            </Form>
            <Form
                v-else
                ref="dataForm"
                :model="formData"
                :labelWidth="150"
                style="padding: 15px 0"
            >
                <FormItem
                    :label="
                        $t('erp.b2c.channel_account', {
                            defaultValue: '渠道账号',
                        })
                    "
                    prop="accountType"
                    :rules="required"
                >
                    <RadioGroup v-model="formData.accountType">
                        <Radio label="all"
                            >{{
                                $t("bi.work.task_all", {
                                    defaultValue: "全部",
                                })
                            }}{{
                                $t("global.common.channel", {
                                    defaultValue: "渠道",
                                })
                            }}</Radio
                        >
                        <Radio label="part">{{
                            $t("erp.rules.partaccount", {
                                defaultValue: "指定渠道",
                            })
                        }}</Radio>
                    </RadioGroup>
                </FormItem>
                <FormItem v-if="formData.accountType === 'part'">
                    <Transfer
                        :data="accountList"
                        filterable
                        :target-keys="targetAccountList"
                        :list-style="listStyle"
                        :render-format="renderList"
                        @on-change="handleAccountChange"
                    >
                    </Transfer>
                </FormItem>
                <FormItem
                    :label="
                        $t('global.common.project', { defaultValue: '项目' })
                    "
                    prop="productType"
                    :rules="required"
                >
                    <RadioGroup v-model="formData.productType">
                        <Radio label="all"
                            >{{
                                $t("bi.work.task_all", {
                                    defaultValue: "全部",
                                })
                            }}{{
                                $t("global.common.project", {
                                    defaultValue: "项目",
                                })
                            }}</Radio
                        >
                        <Radio label="part"
                            >{{
                                $t("fbb.inbound.choose", {
                                    defaultValue: "选择",
                                })
                            }}{{
                                $t("global.common.project", {
                                    defaultValue: "项目",
                                })
                            }}</Radio
                        >
                    </RadioGroup>
                </FormItem>
                <FormItem v-if="formData.productType === 'part'">
                    <Transfer
                        :data="productList"
                        filterable
                        :target-keys="targetProductList"
                        :list-style="listStyle"
                        :render-format="renderList"
                        @on-change="handleProductChange"
                    >
                    </Transfer>
                </FormItem>
                <FormItem label="地址" prop="addressType" :rules="required">
                    <RadioGroup v-model="formData.addressType">
                        <Radio label="all">全部地址</Radio>
                        <Radio label="RES">住宅地址</Radio>
                    </RadioGroup>
                </FormItem>
                <FormItem
                    :label="
                        $t('erp.rules.postlength', { defaultValue: '邮编范围' })
                    "
                >
                    <div class="flex-container" style="display: flex">
                        <div class="input-item">
                            <Input
                                :rows="7"
                                v-model="formData.dataList.postcodeList"
                                type="textarea"
                            ></Input>
                        </div>
                        <div class="tip-item">
                            <div
                                class="tip-p"
                                v-html="
                                    $t('erp.rules.postlength_tip', {
                                        defaultValue:
                                            '<p>填写说明：</p><p>1. 一行一个邮编范围；</p><p>2.20000~30000表示邮编在20000与30000间，并且包含20000和30000；</p><p>3.40000~40000表示只有这一个邮编40000，不可以填写单独的数字。</p><p>举例：</p><p>20000~29999</p><p>40000~49999</p><p>60000~79999</p>',
                                    })
                                "
                            ></div>
                        </div>
                    </div>
                </FormItem>
                <FormItem label="ERPSKU">
                    <div class="flex-container" style="display: flex">
                        <div class="input-item">
                            <Input
                                :rows="7"
                                v-model="formData.dataList.skuList"
                                type="textarea"
                            ></Input>
                        </div>
                        <div class="tip-item">
                            <div
                                class="tip-p"
                                v-html="
                                    $t('erp.rules.cantacterp_tip', {
                                        defaultValue:
                                            '<p>填写说明：</p><p>1.一行一个ERP SKU，精确匹配；</p><p>2.多行表示多个EPR SKU。</p><p>举例：</p<p>STM1301000023</p><p>STM1301000022</p><p>STM1301000021</p>',
                                    })
                                "
                            ></div>
                        </div>
                    </div>
                </FormItem>
                <FormItem label="动态条件">
                    <div class="flex-container" style="display: flex">
                        <div class="input-item">
                            <Input
                                :rows="7"
                                v-model="
                                    formData.dataList.erpskuSizeFormulaList
                                "
                                type="textarea"
                            ></Input>
                        </div>
                        <div class="tip-item">
                            <div
                                class="tip-p"
                                v-html="
                                    $t('erp.rules.order_rules_textarea_html')
                                "
                            ></div>
                        </div>
                    </div>
                </FormItem>
            </Form>
        </compWrapper>
        <Spin v-if="loading" fix size="large"></Spin>
    </div>
</template>

<script>
import {
    HttpGetRuleDetail,
    HttpSaveRuleData,
    HttpFilterDisabledWarehouse,
} from "@/service/rules/rules";
import { mapState, mapGetters } from "vuex";
import mixin from "./mixin";
export default {
    props: ["level", "type", "id"],
    mixins: [mixin],
    data() {
        return {
            ruleId: this.id ? this.id : this.$route.query.id,
            queryType: this.type ? this.type : this.$route.params.type,
            loading: false,
            listStyle: {
                width: "40%",
                minWidth: "260px",
                height: "360px",
            },
            baseInfo: {},
            // formatter: {
            //     skuList: ''
            // },
            formData: {
                accountType: "all",
                productType: "all",
                addressType: "all",
                // 字符串数据
                dataList: {
                    // sku
                    skuList: [],
                    // 邮编
                    postcodeList: [],
                    // 地址
                    addressList: [],
                    // 订单金额
                    orderAmountList: [],
                    // sku数量
                    orderTotalList: [],
                    // 尺寸公式
                    erpskuSizeFormulaList: [],
                    // 承运商服务
                    carrierCodeList: [],
                },
            },
            // 仓库源列表
            warehouseList: [],
            // 渠道源列表
            accountList: [],
            // 渠道数据列表
            targetAccountList: [],
            // 产品源列表
            productList: [],
            // 产品数据列表
            targetProductList: [],
            // 数组，方便统一处理，存放在一个对象中
            dataList: {
                // sku
                skuList: [],
                // 邮编
                postcodeList: [],
                // 地址
                addressList: [],
                // 订单金额
                orderAmountList: [],
                // sku数量
                orderTotalList: [],
                // 尺寸公式
                erpskuSizeFormulaList: [],
                // 承运商服务
                carrierCodeList: [],
            },
            required: {
                required: true,
                message: "",
            },
        };
    },
    watch: {
        // 防止第一次加载接口还未返回值
        getNewAccountIdList: {
            immediate: true,
            deep: true,
            handler(val) {
                this.handleAccountList(val);
            },
        },
        getNewProductList: {
            immediate: true,
            deep: true,
            handler(val) {
                this.handleProductList(val);
            },
        },
    },
    async created() {
        // console.log(this.ruleId, this.queryType, this.orderLevel);
        let filterDisabledWarehouse = [];
        await HttpFilterDisabledWarehouse().then(
            (res) => {
                filterDisabledWarehouse = res.data;
                // console.log(res);
            },
            (err) => {}
        );
        this.warehouseList = filterDisabledWarehouse
            .filter((item) => {
                // 过滤只展示服务仓和虚拟仓
                return item.warehouseType === 1 || item.warehouseType === 5;
            })
            .map((item) => {
                return {
                    label: item.title
                        ? `${item.code}(${item.title})`
                        : item.code,
                    value: item.id,
                    attach: {
                        code: item.code,
                        warehouseType: item.warehouseType,
                    },
                };
            });
        if (this.queryType !== "add") {
            this.loading = true;
            await this.getDetail();
        }
    },
    computed: {
        ...mapGetters("diction", [
            "getNewProductList",
            "getNewAccountIdList",
            "getNewWarehouseIdList",
        ]),
        ...mapGetters("dictionary", ["getFilterDisabledWarehouse"]),
        getBase() {
            return [
                {
                    label: this.$t("erp.rules.rulename", {
                        defaultValue: "规则名称",
                    }),
                    key: "ruleName",
                    span: 24,
                },
                // {
                //     label: this.$t("erp.b2c.search_outwarehouse", {
                //         defaultValue: "发货仓库",
                //     }),
                //     key: "warehouseId",
                //     tag: "vSelect",
                //     options: this.warehouseList,
                //     show: this.orderLevel != 5,
                //     span: 24,
                //     props: {
                //         filterable: true,
                //         clearable: true,
                //     },
                //     on: {
                //         "on-change": (val) => {
                //             this.baseInfo.warehouseName =
                //                 this.warehouseList.filter((item) => {
                //                     return item.value == val;
                //                 })[0].label;
                //         },
                //     },
                // },
                {
                    label: "发货方式",
                    key: "warehouseName",
                    tag: "vSelect",
                    options: this.serviceCodeList,
                    props: {
                        filterable: true,
                        clearable: true,
                    },
                    span: 24,
                },
            ];
        },
    },
    methods: {
        async submit() {
            let flag = true;
            await this.$refs.editform.validate((valid) => {
                flag = valid;
            });
            if (!flag) return;
            await this.$refs.dataForm.validate((valid) => {
                flag = valid;
            });
            if (!flag) return;
            // 处理数据数组
            let resultData = {
                ...this.baseInfo,
                addressType:
                    this.formData.addressType == "all"
                        ? ""
                        : this.formData.addressType,
            };
            // 渠道
            if (this.formData.accountType === "all") {
                resultData.channelList = [
                    {
                        content: "all",
                    },
                ];
            } else {
                resultData.channelList = this.targetAccountList.map((item) => {
                    return {
                        content: item,
                    };
                });
            }
            // 项目
            if (this.formData.productType === "all") {
                resultData.productLineList = [
                    {
                        content: "all",
                    },
                ];
            } else {
                resultData.productLineList = this.targetProductList.map(
                    (item) => {
                        return {
                            content: item,
                        };
                    }
                );
            }
            Object.keys(this.formData.dataList).map((key) => {
                // console.log(this.formData.dataList[key])
                if (
                    !this.formData.dataList[key] ||
                    !this.formData.dataList[key].length
                )
                    this.dataList[key] = [];
                else {
                    this.dataList[key] = this.handleStringToArray(
                        this.formData.dataList[key]
                    );
                }
            });
            for (let i = 0; i < this.dataList.skuList.length; ) {
                let item = this.dataList.skuList[i];
                item.content = item.content.replace(/ +/g, "");
                if (!item.content) {
                    this.dataList.skuList.splice(i, 1);
                } else {
                    i++;
                }
            }
            resultData = {
                ...resultData,
                ...this.dataList,
                ruleType: 4,
                orgId: global.SYSID,
            };
            if (this.queryType === "edit") {
                resultData.id = this.ruleId;
            }
            this.loading = true;
            await HttpSaveRuleData(resultData)
                .then(
                    (res) => {
                        this.$VMessage.success(res.message);
                        this.$router.push({ name: "orderRules" });
                    },
                    (err) => {
                        this.$VMessage.error({
                            content: err.message,
                            duration: 30,
                            closable: true,
                        });
                    }
                )
                .finally(() => {
                    this.loading = false;
                });
        },
        /**
         * 获取详情数据
         */
        async getDetail() {
            await HttpGetRuleDetail({
                ruleId: this.ruleId,
            })
                .then(
                    (res) => {
                        this.baseInfo = {
                            ruleName: res.data.ruleName,
                            warehouseName: res.data.warehouseName,
                            warehouseId: res.data.warehouseId,
                        };
                        // 处理渠道数据
                        if (res.data.channelList[0].content === "all") {
                            this.formData.accountType = "all";
                        } else {
                            this.formData.accountType = "part";
                            this.targetAccountList = this.handleDataArr(
                                res.data.channelList
                            );
                        }
                        // 处理产品数据
                        if (res.data.productLineList[0].content === "all") {
                            this.formData.productType = "all";
                        } else {
                            this.formData.productType = "part";
                            this.targetProductList = this.handleDataArr(
                                res.data.productLineList
                            );
                        }
                        // addressType
                        console.log('地址', res.data.addressType, this.formData.addressType);
                        this.formData.addressType = res.data.addressType
                            ? res.data.addressType
                            : "all";
                        // sfpType
                        this.formData.sfpType = res.data.sfpType;
                        // 获取数据列表
                        let originDataList = {
                            skuList: res.data.skuList,
                            postcodeList: res.data.postcodeList,
                            addressList: res.data.addressList,
                            orderAmountList: res.data.orderAmountList,
                            orderTotalList: res.data.orderTotalList,
                            erpskuSizeFormulaList:
                                res.data.erpskuSizeFormulaList,
                            carrierCodeList: res.data.carrierCodeList,
                        };
                        // 处理数据
                        Object.keys(originDataList).map((item) => {
                            // 存放处理后的数组
                            this.dataList[item] = this.handleDataArr(
                                originDataList[item],
                                false
                            );
                            // 存放展示/编辑用字符串
                            this.formData.dataList[item] =
                                this.handleArrayToString(this.dataList[item]);
                        });
                        // 查询状态 需要不同的数据结构
                        if (this.queryType === "query") {
                            this.targetAccountList = this.targetAccountList.map(
                                (item) => {
                                    let result = this.accountList.filter(
                                        (accountItem) => {
                                            return accountItem.key === item;
                                        }
                                    )[0];
                                    if (!result) return {};
                                    return result.label;
                                }
                            );
                            this.targetProductList = this.targetProductList.map(
                                (item) => {
                                    let result = this.productList.filter(
                                        (accountItem) => {
                                            return accountItem.key === item;
                                        }
                                    )[0];
                                    if (!result) return {};
                                    return result.label;
                                }
                            );
                        }
                    },
                    (err) => {
                        this.$VMessage.error({
                            content: err.message,
                            duration: 30,
                            closable: true,
                        });
                    }
                )
                .finally(() => {
                    this.loading = false;
                });
        },
        cancel() {
            this.$router.push({ name: "orderRules" });
        },
        /**
         * 处理数据源数组
         * @param target 结果数组
         * @param data 从接口拿到的数据源
         */
        handleDataArr(data, needInt = true) {
            return data.map((item) => {
                let result;
                if (needInt) {
                    result = parseInt(item.content);
                } else {
                    result = item.content;
                }
                return result;
            });
        },
        /**
         * 处理数组成字符串
         */
        handleArrayToString(arr) {
            return arr.join("\n");
        },
        /**
         * 将分行的字符串解析为数组
         * @param string 分行的字符串
         */
        handleStringToArray(string) {
            let arr = string.split(/\n/g);
            return arr.map((item) => {
                return {
                    content: item,
                };
            });
        },
        /**
         * 处理select选框在查看状态的展示
         */
        handleSelect(dataSource, data) {
            return dataSource.filter((item) => {
                return item.value === data;
            })[0];
        },
        renderList(item) {
            return item.label;
        },
        /**
         * 处理渠道源列表
         */
        handleAccountList(data) {
            this.accountList = data.map((item) => {
                return {
                    label: item.label,
                    key: item.value,
                };
            });
        },
        handleAccountChange(newTargetKeys, direction, moveKeys) {
            this.targetAccountList = newTargetKeys;
        },
        /**
         * 处理产品源列表
         */
        handleProductList(data) {
            this.productList = data.map((item) => {
                return {
                    label: item.label,
                    key: item.value,
                };
            });
        },
        handleProductChange(newTargetKeys, direction, moveKeys) {
            this.targetProductList = newTargetKeys;
        },
    },
};
</script>